/** @jsxImportSource theme-ui */
import { useBreakpointIndex } from '@theme-ui/match-media';
import React from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { Container, Menu } from 'semantic-ui-react';

import { sxSemanticHackResponsiveVerticalMenu } from 'utils/cssHelpers';
import { isNonMobile } from 'utils/responsive';

import { Typography } from 'components/_common/Typography';

import SettingsFooter from './_common/SettingsFooter';
import SettingsLoader from './_common/SettingsLoader';
import { AccountDetails } from './AccountDetails';
import { CustomSettingsPage } from './CustomSettings';
import { NotificationSettings } from './NotificationSettings';

const SettingsView: React.FC = () => {
  const isNonMobileDevice = isNonMobile(useBreakpointIndex());
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
      }}
    >
      <SettingsLoader />
      <Container
        text
        sx={{
          '&.ui.text.container': {
            display: 'flex',
            flexDirection: 'column',
            minHeight: 'calc(100vh - 44px)', // CODE: b31008c1
          },
        }}
      >
        <div sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <div
            sx={{
              alignSelf: 'center',
              mt: ['20px', '50px'],
              mb: '30px',
              textAlign: ['left', 'center'],
            }}
          >
            <Typography variant="h4" color="deepSea100">
              Settings
            </Typography>
          </div>
          <Menu
            pointing
            secondary
            widths={isNonMobileDevice ? 4 : null}
            className="secondary-vertical-inverted"
            sx={{
              alignSelf: 'center',
              '&.ui.menu': {
                mb: '40px',
              },
              ...sxSemanticHackResponsiveVerticalMenu(),
            }}
          >
            <Menu.Item
              name="Account Details"
              active={location.pathname === '/settings/account'}
              onClick={() => navigate('/settings/account')}
            />
            <Menu.Item
              name="Insights Settings"
              active={location.pathname === '/settings/customsettings'}
              onClick={() => navigate('/settings/customsettings')}
            />
            <Menu.Item
              name="Notifications"
              active={location.pathname === '/settings/notifications'}
              onClick={() => navigate('/settings/notifications')}
            />
          </Menu>
          <Routes>
            <Route path="account" element={<AccountDetails />} />
            <Route path="customsettings" element={<CustomSettingsPage />} />
            <Route path="notifications" element={<NotificationSettings />} />
          </Routes>
        </div>

        <SettingsFooter />
      </Container>
    </div>
  );
};

export default SettingsView;
